import QueryConstants from '../constants/QueryConstants';
import StringConstants from '../constants/StringConstants';

const contextUtils = {
  /** Returns true if the redirect query param is payments. Accepts a full URL, a path with a query, or a search string. */
  isRedirectToPayments(urlOrSearch = '') {
    const search = urlOrSearch.split('#')[0];
    const queryParams = new URLSearchParams(search.slice(search.indexOf('?') + 1));
    return queryParams.get(QueryConstants.REDIRECT_TO) === StringConstants.REDIRECT_TO.PAYMENTS;
  },
};

export default contextUtils;
